<template>

    <m-edit1/>

    <m-form-answer-1 v-bind='{...{"answerPages":"[ { \"answer\": \"damavi\", \"page\": \"https:\/\/tabibekhanevade.ir\/damavi\" }, { \"answer\": \"safravi\", \"page\": \"https:\/\/tabibekhanevade.ir\/safravi\" }, { \"answer\": \"balghami\", \"page\": \"https:\/\/tabibekhanevade.ir\/balghami\" }, { \"answer\": \"sovdavi\", \"page\": \"https:\/\/tabibekhanevade.ir\/sovdavi\" }, { \"answer\": \"etedal\", \"page\": \"https:\/\/tabibekhanevade.ir\/etedal\" } ]"},...{}}' :style='""' class="text-center my-5" ></m-form-answer-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFormAnswer1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormAnswer/FormAnswer1';

export default {
    name: 'HomeView',
    components: {mEdit1, mFormAnswer1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
